<img class="pointercl" [src]="Menu.FotoUrl" alt="Afdruk" width="70" height="70" class="center" (click)="onclick(Menu)">
<div>
    <h4 class="text-uppercase text-strong text-center text-l-size-12 text-m-size-12 text-s-size-12 pointercl" (click)="onclick(Menu)">{{translate(Menu)}}</h4>
    <a class="text-more-info text-aqua-hover text-center pointercl" (click)="onclick(Menu)">{{translateString('Klik hier')}}</a>    
</div>